import React from 'react';
import styled from 'styled-components';

const DownloadsStyled = styled.div`
  max-width: 1000px;
  width: 100%;
  margin: 2rem 0;
  padding: 2rem;
  background: var(--backgroundCard);
  border-radius: var(--borderRadius);
  box-shadow: var(--boxShadow);
  h5 {
    font-size: 1.5rem;
  }
  @media (max-width: 1023px) {
    width: auto;
    margin: 1rem;
    padding: 1rem;
  }
  ul li {
    margin-bottom: 1rem;
  }
`;

export default function Downloads({ files = props }) {
  return (
    <DownloadsStyled>
      <h5>Downloads</h5>
      <ul>
        {files.map((item, index) => (
          <li key={index}>
            <a
              href={item?.download?.asset.url}
              target="_blank"
              rel="noreferrer"
            >
              {item.fileName}
            </a>
          </li>
        ))}
      </ul>
    </DownloadsStyled>
  );
}
